<template>
    <div name="sAddToBasket" class="buybox--form" data-add-article="true" data-eventname="submit" data-showmodal="false">
        <div v-if="! viewport.isMobile" class="buybox--button-container">
            <div class="buybox--quantity">
                <input type="text" class="is--quantityInput" pattern="\d*" v-model="quantity" @change="handleQuantity">
                <div class="is--quantityHandler">
                    <span class="label-plus" @click="increase">+</span>
                    <span class="label-minus" @click="decrease">-</span>
                </div>
            </div>
            <button
                class="buybox--button btn is--third is--icon-left is--center is--large"
                @click="addToBasket"
                :disabled="1 > plexipeople.length || isLoading">
                <img v-if="isLoading" src="/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/loading.svg" alt="Loading">
                <i class="icon--basket" v-else></i>
                {{ $t('basket.addToBasketDesktop') }}
            </button>
        </div>

        <!-- On mobile viewports-->
        <div v-if="viewport.isMobile" class="buybox--button-container">
            <button
                :class="[ { 'is--loading': isLoading }, 'buybox--button', 'btn', 'is--primary', 'is--center' ]"
                @click="addToBasket"
                :disabled="1 > plexipeople.length || isLoading"
            >
                <template v-if="0 === plexipeople.length">{{ $t('basket.empty') }}</template>
                <template v-else>{{ $t('basket.addToBasket') }} {{ price }} {{ $t('basket.addToBasket2') }}</template>

            </button>
        </div>
    </div>
</template>

<script>
    import { removeURIParams } from "../utilities";
    import EventBus from '../event-bus';
    import { gtag_event } from "../gtag";

    export default {
        data() {
            return {
                isLoading: false,
                min: 1,
                max: 25,
                quantity: 1,
            };
        },

        props: {
            viewport: Object,
            base: Object,
            plexipeople: Array,
            price: Number,
            quantity: {
                type: Number,
                default() {
                    return 1;
                }
            },
            record: {
                type: [ Number, Boolean ],
                default() {
                    return false;
                },
            },
        },

        methods: {
            handleQuantity() {
                if (this.max < this.quantity) {
                    this.quantity = this.max;
                } else if (this.min > this.quantity) {
                    this.quantity = this.min;
                }

                this.$emit('quantity-changed', this.quantity);
            },

            increase() {
                this.quantity ++;
                this.handleQuantity();
            },

            decrease() {
                this.quantity --;
                this.handleQuantity();
            },

            addToBasket() {
                gtag_event('Button Warenkorb');

                this.isLoading = true;

                let requestBody = {
                    quantity: this.quantity,            // number of configured product
                    base: {                             // false on order without base
                        material: {
                            id: App.configuration.variants.materials.id,
                            value: this.base.material
                        },
                        color: {
                            id: App.configuration.variants.colors.id,
                            value: this.base.color
                        },
                        grooves: {
                            id: App.configuration.variants.grooves.id,
                            value: this.base.grooves
                        },
                        width: {
                            id: App.configuration.variants.widths.id,
                            value: this.base.width
                        }
                    },
                    record: this.record,
                    plexipeople: []
                };

                this.plexipeople.forEach((position) => {
                    requestBody.plexipeople.push({
                        extraction: {
                            coords: position.extraction.coords,
                            parent: {
                                source: removeURIParams(position.extraction.parent.source),
                                origin: removeURIParams(position.extraction.parent.origin || ''),
                                uuid: position.extraction.parent.uuid
                            },
                            source: removeURIParams(position.extraction.source),
                            geometry: position.extraction.geometry
                        },
                        groove: position.groove,
                        x: position.x / this.viewport.factor,
                        y: position.y / this.viewport.factor,
                        height: (position.height / this.viewport.factor) * 10,
                        width: (position.width / this.viewport.factor) * 10,
                        uuid: position.uuid,
                        indicator: position.indicator
                    });
                });

                this.$http.post(App.url.addToBasketAction, requestBody).then(
                    // Successful
                    response => {
                        EventBus.$emit('removeLeavingEditorEventListener');
                        window.location.href = App.url.swCartAction;
                    },
                    // Errors occurs
                    response => {
                        this.isLoading = false;
                    }
                );
            }
        },

        mounted() {
            EventBus.$on('triggerBuyButton', this.addToBasket);
        },

        beforeDestroy() {
            EventBus.$off('triggerBuyButton', this.addToBasket);
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/components/buy-button";
</style>



// WEBPACK FOOTER //
// src/components/BuyButton.vue